export const CASH_SETTLEMENT_HISTORY_HEADER_CLASS_NAME =
  'whitespace-nowrap text-center';

export const CASH_SETTLEMENT_HISTORY_AMOUNT_CELL_CLASS_NAME =
  'whitespace-nowrap tabular-nums';

export const CASH_SETTLEMENT_HISTORY_TEXT_CELL_CLASS_NAME = 'whitespace-nowrap';

export const CASH_SETTLEMENT_HISTORY_COLUMN_WIDTHS = {
  settlementDate: 128,
  beginningCashAmount: 136,
  treasuryCashInAmount: 104,
  treasuryCashOutAmount: 104,
  systemCashSales: 184,
  expectedCash: 168,
  verifiedCashAmount: 168,
  nonCashTotal: 168,
  varianceAmount: 132,
  note: 180,
  cashCounter: 136,
  createTime: 172,
} as const;

export const CASH_SETTLEMENT_HISTORY_TABLE_SCROLL_X = 1840;

export const CASH_SETTLEMENT_HISTORY_DETAIL_SCROLL_X = 760;
